import { defineNuxtPlugin, useRuntimeConfig, } from 'nuxt/app';

// Checking the User-Agent because firebase doesn't play well with some in-app browsers like facebook/instagram
function isRestrictedInAppBrowser(userAgentString) {
  if (!userAgentString) {
    return false;
  }
  const ua = userAgentString.toLowerCase();

  /******* THESE CAN CHANGE OVER TIME, check user agents if service worker failure on in app browsers *******/
  const isInstagram = ua.includes('instagram');
  const isFacebook = ua.includes('fbios') || ua.includes('fbav'); // Common Facebook app identifiers

  return isInstagram || isFacebook;
}

export default defineNuxtPlugin(async(nuxtApp) => {
  // Firebase is client-only — skip entirely on the server.
  // Lazy-importing here keeps the firebase chunks out of the initial page parse;
  // they are only downloaded and executed when this plugin actually runs on the client.
  if (!import.meta.client) {
    nuxtApp.vueApp.provide('messaging', null);
    nuxtApp.provide('messaging', null);
    return;
  }

  const config = useRuntimeConfig();
  const userAgent = navigator.userAgent;
  let messaging = null;

  if (isRestrictedInAppBrowser(userAgent)) {
    console.warn(
      'Firebase Messaging: Detected a restricted in-app browser. Messaging might be disabled or limited.'
    );
  } else {
    try {
      // Dynamic imports — firebase/app and firebase/messaging are only fetched
      // after the browser check passes, keeping them off the critical parse path.
      const { initializeApp } = await import('firebase/app');
      const { getMessaging } = await import('firebase/messaging');
      const app = initializeApp(config.public.firebase.config);
      messaging = getMessaging(app);
    } catch (e) {
      console.error('Error initializing Firebase Messaging:', e);
    }
  }

  nuxtApp.vueApp.provide('messaging', messaging);
  nuxtApp.provide('messaging', messaging);
});
